<template>

    <div class="payouts-container">
        <Title :title="getTranslatedText('payouts')" />
        <div class="payouts-header">
            <TabGame @game-default="handleInitGame" @select-game="onSelectGame" />
            <p class="payouts-header__title">{{ getTranslatedText('odds') }}</p>
        </div>
        <Loading v-if="isLoading" />
        <template v-else>
            <div v-if="payoutsAllowGame.length > 0" class="payouts-content">
                <div class="payouts-item" v-for="(item, index) in payoutsAllowGame" :key="index">
                    <p class="title" v-if="item.details.length > 1">{{ getTranslatedText(item.description) }}</p>
                    <div class="details" v-for="(payout, i) in item.details" :key="i">
                        <p :class="{ 'outcome-name': item.details.length == 1 }">
                            {{ getTranslatedText(payout.name) }}
                        </p>
                        <p class="value">{{ formatPrice(payout.odds) }}</p>
                    </div>
                </div>
            </div>
            <EmptyComponent v-else :description="getTranslatedText('empty payouts')" />
            <div class="payouts-link">
                <p>{{ getTranslatedText("for all historical results and statistics plese visit") }}&nbsp; <a
                        href="https://www.49s.co.uk/" target="_blank">49s.co.uk</a></p>
            </div>
            <ButtonCommon text="back home" class="button__custom-1" @action="backToHome" />
        </template>

    </div>
</template>
<script>
import languageMixins from "@/mixins/language-mixins";
import utilsMixins from "@/mixins/function-utils";
import Loading from '@/components/common/loading/loading.vue'
import ButtonCommon from "@/components/common/button";
import Title from "@/components/common/title/index.vue";
import EmptyComponent from '@/components/common/empty';
import TabGame from "@/components/common/tab/tab-game.vue"

import payoutService from "@/services/payouts/index.service.ts";
import { notifyApiError } from "@/utils/notify";
import { getStateStore } from "@/utils/utils.ts"

export default {
    mixins: [languageMixins, utilsMixins],
    components: { ButtonCommon, Title, EmptyComponent, TabGame, Loading },
    data() {
        return {
            isLoading: false,
            payouts: [],
            payoutsAllowGame: [],
            currentGame: {},
            currencySymbol: ''
        }
    },
    created() {
        const { currency_symbol } = getStateStore().accountSetting;
        this.currencySymbol = currency_symbol;
        this.fetchPayouts();
    },
    methods: {
        async fetchPayouts() {
            this.isLoading = true;
            try {
                let res = await payoutService.getPayouts();
                if (res.status == 'success') {
                    this.payouts = res.result;
                    this.applyPayoutsForGame();
                }
            } catch (error) {
                notifyApiError(error);
            } finally {
                this.isLoading = false;
            }
        },

        applyPayoutsForGame() {
            if (!this.currentGame?.slug) {
                this.payoutsAllowGame = [];
                return;
            }
            this.payoutsAllowGame = this.payouts.filter(
                (x) => x.slug === this.currentGame.slug
            );
        },

        handleInitGame(game) {
            if (!game) return;
            this.currentGame = game;
            this.applyPayoutsForGame();
        },

        onSelectGame(game) {
            this.currentGame = game;
            this.applyPayoutsForGame();
        },

        backToHome() {
            const query = this.$route.query;
            this.$router.push({ path: "/", query });
        }
    }
}
</script>

<style lang="scss">
@import "@/public/scss/payouts/index.scss";
</style>